module.exports = "/images/toggle-switch-tick.svg?b28ded9bf239db5c9a6189eb2d0f3a43";